import _ from "lodash";
import { VAR_TYPE } from './index';
export class MarketingCardService {
    constructor(params) {
        /**
         * bo用来遍历展示表单组件
         */
        this.formConfig = [];
        this.disposes = [];
        this.el = undefined;
        this.currentLang = params.lang;
        this._originCard = params.card || {};
        this.clickFunc = params.clickFunc;
    }
    setOriginCard(card) {
        const resultCard = {
            ...this._originCard,
            ...card
        };
        this._originCard = resultCard;
    }
    get card() {
        const card = {};
        _.forEach(this.formConfig, (v) => {
            if (v.type === VAR_TYPE.TEXT) {
                // @ts-ignore
                card[`${v.key}`] = this._originCard[`${v.key}_${this.currentLang}`];
            }
            else {
                // @ts-ignore
                card[`${v.key}`] = this._originCard[`${v.key}`];
            }
        });
        return card;
    }
    render() {
        return document.createElement('div');
    }
    dispose() { }
}
//# sourceMappingURL=base.js.map